import React from 'react';

const Heading = ({ heading }) => {
    return (
        <div className='font-semibold tracking-wider text-black text-2xl'>{heading}</div>
    )
}

export default Heading